import React, {
  useRef,
  useEffect,
  useState,
  useReducer,
  useContext,
} from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, FormElement } from "@progress/kendo-react-form";
import "./dialog-sign.css";
import CanvasDraw from "@win11react/react-canvas-draw";
import { PDFDocument } from "pdf-lib";
import { Document, Page, pdfjs } from "react-pdf";

import { useMediaQuery } from "@material-ui/core";
import { Context } from "../../../Context";
import { getStampTimeAndTimezone } from "../../../utils";
import { ButtonHLPure, DialogSystemGLPure, FaceRecognition, SimpleLoading } from "..";
import { ValidationCodePure } from "../../pures"
import OldP5Contianer from "./oldP5Container";
const gotToEnd = () => {
  let out = document.getElementsByClassName("k-dialog-content");
  // out[0].scrollTop = out[0].scrollHeight * 0.7;
};
let yPositionCanvas = {
  y1: 205,
  y2: 235,
  y3: 275
}

const saveImage = (proofOfLife) => {
  let image
  let destinationCanvas
  if (!proofOfLife) {
    let sourceCanvas = document.getElementsByTagName("canvas")[1];
    destinationCanvas = document.createElement("canvas");
    destinationCanvas.height = sourceCanvas.height;
    destinationCanvas.width = sourceCanvas.width;
    let destinationContext = destinationCanvas.getContext("2d");
    destinationContext.drawImage(sourceCanvas, 0, 0);
    destinationContext.globalCompositeOperation = "destination-over";
    destinationContext.fillStyle = "#4484a500";
    destinationContext.fillRect(
      0,
      0,
      destinationCanvas.width,
      destinationCanvas.height
    );
    image = destinationCanvas.toDataURL("image/png");
  } else {
    let sourceCanvas = document.getElementsByTagName("canvas")[1];
    let sourceSign = document.getElementsByTagName("canvas")[2]
    destinationCanvas = document.createElement("canvas");
    destinationCanvas.height = sourceCanvas.height;
    destinationCanvas.width = sourceCanvas.width;
    let destinationContext = destinationCanvas.getContext("2d");
    destinationContext.drawImage(sourceCanvas, 0, 0);
    destinationContext.drawImage(sourceSign, 0, 0);
    destinationContext.globalCompositeOperation = "destination-over";
    destinationContext.fillStyle = "#4484a500";
    destinationContext.fillRect(
      0,
      0,
      destinationCanvas.width,
      destinationCanvas.height
    );
    image = destinationCanvas.toDataURL("image/png");
  }
  return {
    newImg: image,
    imageWidth: destinationCanvas.width,
    imageHeight: destinationCanvas.height,
  };
};

function setTextInCanvas(x, y, text, isMobile) {
  try {
    let sourceCanvas = document.getElementsByTagName("canvas")
    const gottenCanvas = sourceCanvas[1]
    let ctx = gottenCanvas.getContext("2d");
    //Corregir a 11px para móvil
    isMobile ? ctx.font = "bold 13px Arial" : ctx.font = "bold 23px Arial"
    ctx.textAlign = "center";
    ctx.fillText(text, !isMobile ? gottenCanvas.width / 2 : (gottenCanvas.width / 2), y, gottenCanvas.width);
  } catch (error) { }
}

function setImageInCanvas(img) {
  const image = new Image()
  image.src = img
  try {
    let sourceCanvas = document.getElementsByTagName("canvas")[1];
    let ctx = sourceCanvas.getContext("2d");
    let height = sourceCanvas.height;
    let width = sourceCanvas.width;
    image.onload = () => ctx.drawImage(
      image,
      0,
      0,
      width,
      height - 30
    )
  } catch (error) { }
}

function setNamesInCanvas(firstName, lastName, isMobile) {
  if (isMobile) {
    yPositionCanvas = {
      y1: (window.innerWidth / 2.09) - 60,
      y2: (window.innerWidth / 2.09) - 40,
      y3: (window.innerWidth / 2.09) - 20
    }
  }
  if (firstName.length + lastName.length > 26) {
    setTextInCanvas(0, yPositionCanvas.y1, `${firstName}`, isMobile)
    setTextInCanvas(0, yPositionCanvas.y2, `${lastName}`, isMobile)
  } else {
    setTextInCanvas(0, yPositionCanvas.y2, `${firstName} ${lastName}`, isMobile)
  }
}

const initialValuesState = {
  activeOnSubit: false,
  signatureData: {},
};

function valuesReducerActions(state, action) {
  switch (action.type) {
    case "setActiveOnSubit":
      return { ...state, activeOnSubit: action.data };
    default:
      throw new Error();
  }
}

const OldDialogAcceptSignatureAutografaCustom = (props) => {
  let signatureImg = props.autographySign
  const { setCanvasData, setShowSignatureCanvas } = useContext(Context);
  let name = props?.currentUserName ?? "";
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  const [currentSystem, setCurrentSystem] = useState("");
  const { t } = useTranslation();
  const pad = useRef(null);
  const [step, setStep] = useState(props.noRenderSign ? "sign" : "location");
  const [pagesSize, setPagesSize] = useState([]);
  const [imgSignature, setImgSignature] = useState(null);
  const [widthImgSignature, setWidthImgSignature] = useState(400);
  const [heightImgSignature, setHeightImgSignature] = useState(300);
  const [pagesImgs, setPagesImgs] = useState([]);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(0);
  const [pager, setPager] = useState(1);
  const greyTextRef = useRef(null);
  const [tempImgPages, setTempImgPages] = useState({});
  const [values, dispatchValues] = useReducer(
    valuesReducerActions,
    initialValuesState
  );

  const [showLoading, setShowLoading] = useState(false)

  const [tempDimentions, setTempDimentions] = useState({ width: 0, height: 0 })
  const [clicAvailable, setClicAvailable] = useState(false);
  const [nip, setNip] = useState('');

  const [sign, setSign] = useState(1);
  const [numSign, setNumSign] = useState(0);
  const [currentSign, setCurrentSign] = useState({})

  const [wasChanged, setWasChanged] = useState(false);
  const mimeType = "video/mp4";
  /** @type {[MediaStream, import("react").Dispatch<MediaStream>]} */
  const [stream, setStream] = useState(null);

  /** @type {[boolean, React.Dispatch<boolean>]} */
  const [proofOfLifeValid, setProofOfLifeValid] = useState(false)

  /** @type {React.MutableRefObject<MediaRecorder>} */
  const mediaRecorder = useRef(null)
  /** @type {React.MutableRefObject<HTMLCanvasElement>} */
  const canvasRef = useRef(null)

  const [audioChunks, setAudioChunks] = useState([]);
  const [status, setStatus] = useState("waiting")

  /** @type {Blob} */
  let bufferVideo = new Blob()

  const [imageData, setImageData] = useState(new Blob())

  const videoRef = useRef(null)

  let coordinates = props.currentUser.coordinates?.data
  let pdfFile =
    "data:application/pdf;filename=file.pdf;base64," + props.signRequestPDF;
  let greyText =
    step === "sign"
      ? props.baseSign ? "dialogAcceptSignature.noticeCreateSignAutografaBase" : "dialogAcceptSignature.noticeCreateSignAutografa"
      : "dialogAcceptSignature.noticeCreateSignAutografaCustomSign";
  let infodevice = currentSystem.toLowerCase();
  let isMobile = infodevice.includes("android");
  isMobile = isMobile || infodevice.includes("iphone");
  isMobile = isMobile || infodevice.includes("ipad");
  isMobile = isMobile || infodevice.includes("mobile");
  const isTouchScreendevice = () =>
    "ontouchstart" in window || navigator.maxTouchPoints;
  if (isTouchScreendevice()) isMobile = true;
  useEffect(() => {
    const divGreyText = greyTextRef.current;
    // if (divGreyText) {
    //   if (divGreyText.clientWidth) {
    //     setdivGreyTextSize(divGreyText.clientWidth);
    //   }
    // }
  }, [props.visibleAccept]);

  useEffect(() => {
    let tempArr = [...Array(numPages)];
    for (const key in tempImgPages) {
      tempArr[Number(key)] = tempImgPages[key];
    }
    setPagesImgs(tempArr);
  }, [numPages, tempImgPages]);

  const getPdgPageSize = async () => {
    const pdfDoc = await PDFDocument.load(pdfFile);
    const pages = pdfDoc.getPages()
    let sizes = pages.map((i) => i.getSize());
    setPagesSize(sizes);
  };

  const onDocumentLoadSuccess = (params) => {
    setNumPages(params.numPages);
    // setPageNumber(coordinates ? coordinates[sign - 1]?.page : params.numPages);
    // setPageNumber(params.numPages);
    if (props.documentNameToShowInSign && props.documentsPackage && props.documentsPackage.length > 0 && props.documentsPackage[0].groupName === process.env.REACT_APP_DOCUMENT_PROFILE_DEFAULT_GROUPNAME) {
      let coorFind = coordinates.filter(coordinate => coordinate.document === props.documentNameToShowInSign)
      coordinates = coorFind
    }

    setPager(params.numPages);
    setPageNumber(coordinates ? coordinates[sign - 1]?.page : params.numPages);
  };

  const changePage = (offset) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
    setPager((prevPageNumber) => prevPageNumber + offset);
  };

  const changePageSign = (offset) => {
    setSign(offset);
    if (coordinates[offset - 1].page === pageNumber) {
      return
    } else {
      setTempImgPages("")
      setPageNumber(coordinates[offset - 1].page)
    }
  };

  const keyDown = (e) => {
    if (e.key === "Enter") {
      if (sign === "" || sign === 0) {
        return
      }
      changePageSign(sign)
    } else if (e.key === "Backspace") {
      setSign("")
    } else if (e.key === "0") {
      setSign(0)
    } else if (typeof Number(e.key) === "number" && Number(e.key) > 0) {
      if (Number(e.key) < coordinates.length) {
        setSign(Number(e.key))
      } else {
        setSign(coordinates.length)
      }
    }
  }

  /**
   * @param {MediaStream} streamData
   * @param {Blob} imgData
   */
  const startRecording = async (streamData, imgData) => {
    if (mediaRecorder.current) return
    setStream(streamData)
    setImageData(imgData)
    // setRecordingStatus("recording");
    //create new Media recorder instance using the stream
    const media = new MediaRecorder(streamData, { type: mimeType });
    //set the MediaRecorder instance to the mediaRecorder ref
    mediaRecorder.current = media;
    //invokes the start method to start the recording process
    mediaRecorder.current.start();
    let localAudioChunks = [];
    mediaRecorder.current.ondataavailable = (event) => {
      if (typeof event.data === "undefined") return;
      if (event.data.size === 0) return;
      localAudioChunks.push(event.data);
    };
    setAudioChunks(localAudioChunks);
  }

  const stopRecording = async () => new Promise((resolve) => {
    // setRecordingStatus("inactive");
    //stops the recording instance
    mediaRecorder.current.stop();
    mediaRecorder.current.onstop = async () => {
      //creates a blob file from the audiochunks data
      const audioBlob = new Blob(audioChunks, { type: mimeType });
      //creates a playable URL from the blob file.
      setAudioChunks([]);
      bufferVideo = audioBlob
      stream.getTracks().forEach(track => track.stop())
      videoRef.current.srcObject.getTracks().forEach(track => track.stop())
      resolve()
    };
  })

  const cancelRecording = () => {
    if (stream) {
      stream.getTracks().forEach(track => track.stop())
      setStream(null)
    }
    if (videoRef.current && videoRef.current.srcObject) {
      videoRef.current.srcObject.getTracks().forEach(track => track.stop())
    }
    if (mediaRecorder.current) {
      mediaRecorder.current.stop()
      mediaRecorder.current.onstop = () => {
        //creates a playable URL from the blob file.
        setAudioChunks([]);
        mediaRecorder.current = null
      }
    }
    setProofOfLifeValid(false)
  }

  const previousSign = () => {
    if (sign <= 1) return;
    changePageSign(sign - 1);
  };

  const nextSign = () => {
    if (sign >= numSign) return;
    changePageSign(sign + 1);
  };


  useEffect(() => {
    setNumSign(coordinates?.length);
    if (coordinates?.length >= 1) {
      setSign(1);
    }
  }, [coordinates]);

  useEffect(() => {
    if (sign > numSign) {
      setSign(1);
    }
  }, [sign]);

  useEffect(() => {
    setCurrentSystem(navigator.userAgent);
  }, []);

  useEffect(() => {
    if (props.signRequestPDF) getPdgPageSize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.signRequestPDF]);

  useEffect(() => {
    if (
      props.visibleAccept &&
      !props.showLoadingRequesting &&
      props.currentSignaturetype.id ===
      Number(process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA) &&
      step === "sign"
    ) {
      setTimeout(() => {
        if (!props.baseSign) setNamesInCanvas(props.tokenUserNames, props.tokenUserLastnames, isMobile)
      }, 100);
    }
  }, [
    props.currentSignaturetype.id,
    props.showLoadingRequesting,
    props.tokenUserLastnames,
    props.tokenUserNames,
    props.visibleAccept,
    step,
  ]);
  let pagesNumTemp = [...Array(numPages)];

  const onRender = (params) => {
    const importPDFCanvas = document.querySelector(
      `.import-pdf-page-${pageNumber} canvas`
    );
    const pdfAsImageSrc = importPDFCanvas.toDataURL();
    setTempImgPages(pdfAsImageSrc)
    setTempDimentions({ width: params.width, height: params.height })
  }

  const validateNip = async (cleanInputs) => {
    setShowLoading(true)
    setClicAvailable(false)
    let validNip = await props.validateNip(nip, setNip)
    if (validNip) {
      setShowLoading(false)
      setTimeout(() => {
        setImageInCanvas(signatureImg)
        setClicAvailable(true)
      }, 100);
    } else {
      if (cleanInputs) cleanInputs()
      setShowLoading(false)
      setClicAvailable(false)
    }
  }

  const isPhone = useMediaQuery("(max-width:500px)");
  if (isMobile)
    greyText = "dialogAcceptSignature.noticeCreateSignAutografaMobile";

  return (
    <div>
      {/* <img src={signatureImg} /> */}
      {props?.signatureRequest?.signRequest?.signRequestStatus?.id ===
        Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_PENDING) ? (
        <div className={(step === "sign" && props.currentUser && props.currentUser.proofOfLife) ? isMobile ? "dialogContent-proofOfLifeMobile" : "dialogContent-proofOfLife" : "dialogContent"}>
          {props.authorizerCanSign &&
            props.currentSignaturetype.id ===
            Number(process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA) && (
              <ButtonHLPure
                nameBtn={t("button.authorize")}
                primary
                onClickBtn={() => props.setIsShowAutorizationModal()}
              />
            )}
          {props.userCanSign &&
            props.currentSignaturetype.id ===
            Number(process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA) && (
              <ButtonHLPure
                nameBtn={t("button.sign")}
                primary
                onClickBtn={() => {
                  if (isMobile && !props.currentUser.proofOfLife) setStep("sign")
                  props.toggleDialogAccept()
                }
                }
              />
            )}
          {/* <DialogSystemGLPure
              showLoadingRequesting={showLoading}
              toggleLoadingRequesting={() => setShowLoading(false)}
            /> */}
          {props.visibleAccept &&
            !props.showLoadingRequesting &&
            props.currentSignaturetype.id ===
            Number(process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA) && (
              <Dialog
                title={t("dialogAcceptSignature.titleAcceptSignRequest", {
                  signatureType: props.currentSignaturetype.name,
                })}
                onClose={() => {
                  if (props.currentUser.proofOfLife) cancelRecording()
                  setNip('')
                  props.onDeleteDataAccept()
                }}
                className={props.currentUser.proofOfLife && step === "instructions" ? "dialogContent-proofOfLife" : "dialog-signature"}
              >
                <div
                  ref={greyTextRef}
                  style={{
                    // maxWidth: `645px`,
                    height: "auto",
                    maxWidth: "632px",
                    backgroundColor: "#DEDEDE",
                    position: isPhone && step !== "sign" ? "fixed" : "",
                    // top: 0,
                    zIndex: 1,
                  }}
                >
                  {!props.currentUser.proofOfLife &&
                    <div style={{ padding: "15px 35px 15px 35px" }}>
                      <p
                        style={{
                          margin: "0px",
                          fontFamily: "Quicksand, sans-serif",
                          // paddingBottom: "10px",
                        }}
                      >
                        {t(greyText)}
                      </p>{" "}
                      {(greyText ===
                        "dialogAcceptSignature.noticeCreateSignAutografa" && !props.baseSign) && (
                          <p
                            style={{
                              margin: "0px",
                              fontFamily: "Quicksand, sans-serif",
                            }}
                          >
                            {t("dialogAcceptSignature.noticeCreateSignAutografa2")}
                          </p>
                        )}
                    </div>
                  }
                </div>
                <div
                  className={props.currentUser.proofOfLife && "dialog-all-height"}
                >
                  <Form
                    style={{ margin: "0px" }}
                    onSubmit={props.onSubmit}
                    allowSubmit={true}
                    className="formCustomSignature"
                    valid={true}
                    touched={true}
                    visited={true}
                    render={() => {
                      return (
                        <FormElement
                          className={props.currentUser.proofOfLife && "dialog-all-height"}
                          style={{
                            maxWidth: "450px !important",
                            width: "100%",
                            margin: "auto",
                          }}
                        >
                          <div
                            className={props.currentUser.proofOfLife && "dialog-all-height"}
                          >
                            {step === "sign" && (
                              <>
                                <div className={(props.currentUser && props.currentUser.proofOfLife) ? "canvas-draw-proofOfLife" : "canvas-draw"}>
                                  {(props.currentUser.proofOfLife) &&
                                    <div className="dialogAcceptSignatureAutografaCustom-face">
                                      <FaceRecognition
                                        setImageData={setImageData}
                                        videoRefProp={videoRef}
                                        setRecordingStatus={setStatus}
                                        recordingStatus={status}
                                        startRecording={startRecording}
                                        setStream={setStream}
                                        setFaceState={setProofOfLifeValid}
                                        canvasRef={canvasRef}
                                      />
                                    </div>
                                  }
                                  {!showLoading ?
                                    <CanvasDraw
                                      ref={pad}
                                      loadTimeOffset={0}
                                      lazyRadius={2}
                                      brushRadius={2}
                                      brushColor={"#000"}
                                      catenaryColor={"#0a0302"}
                                      gridColor={"rgba(150,150,150,0.17)"}
                                      hideGrid={true}
                                      canvasWidth={isMobile ? "95%" : 627}
                                      canvasHeight={(isMobile) ? window.innerWidth / 2.09 : 300}
                                      disabled={!props.currentUser.proofOfLife ? (props.baseSign ? true : false) : !proofOfLifeValid} //VARIABLE DE FUNCION AQUI
                                      immediateLoading={true}
                                      hideInterface={false}
                                      onChange={() => !props.currentUser.proofOfLife && setClicAvailable(true)}
                                    />
                                    : <SimpleLoading />
                                  }
                                </div>
                              </>
                            )}
                            {step === "location" && (
                              <div
                                style={{
                                  width: pagesSize[0].width + 16,
                                  height: pagesSize[0].height + 16,
                                }}
                              >
                                <div
                                  className={`button-dialog-accept button-dialog-accept-size icons-bars`}
                                >
                                  <span
                                    class="k-icon k-i-arrow-double-60-left icon-bar"
                                    onClick={() => {
                                      changePageSign(1)
                                    }}
                                  ></span>
                                  <span
                                    class="k-icon k-i-arrow-60-left icon-bar"
                                    // onClick={previousPage}
                                    onClick={previousSign}
                                  ></span>
                                  <div
                                    className="pagec"
                                    style={{
                                      color: "#427FBA",
                                      textAlign: "center",
                                      fontWeight: "bold",
                                      marginTop: "auto",
                                      marginBottom: "auto",
                                      padding: '0px 5px'
                                    }}
                                  >
                                    {t("dialogAcceptSignature.paginationName")}
                                    {/* Página */}
                                    <input
                                      style={{
                                        width: "32px",
                                        marginLeft: "4px",
                                        marginRight: "3px",
                                      }}
                                      type="text"
                                      value={sign}
                                      onKeyDown={e => keyDown(e)}
                                    />
                                    {t("documentDisplay.of")}{" "}
                                    {coordinates.length || "--"}
                                    {/* de {numPages || "--"} */}
                                  </div>
                                  <span
                                    class="k-icon k-i-arrow-60-right icon-bar"
                                    onClick={nextSign}
                                  // onClick={nextPage}
                                  ></span>
                                  <span
                                    class="k-icon k-i-arrow-double-60-right icon-bar"
                                    onClick={() => {
                                      changePageSign(coordinates.length)
                                    }}
                                  ></span>
                                </div>
                                {/* {pagesImgs.map((item, index) => (
                                    <React.Fragment key={String(index)}> */}
                                <div
                                  style={
                                    pageNumber
                                      ? {}
                                      : { display: "none" }
                                  }
                                >
                                  {tempImgPages &&
                                    <OldP5Contianer
                                      {...props}
                                      currentUser={props.currentUser.name}
                                      base64Img={tempImgPages}
                                      widthImg={tempDimentions.width}
                                      heightImg={tempDimentions.height}
                                      imgSignature={imgSignature}
                                      coordinates={coordinates}
                                      signatures={props.signatures}
                                      currentPage={pageNumber}
                                      insertSign={(data) => {
                                        setCurrentSign(data)
                                        setSign(data.index + 1)
                                        setStep(props.currentUser.proofOfLife ? "instructions" : "sign")
                                        // setStep("sign")
                                        setClicAvailable(false)
                                      }}
                                      widthImgSignature={widthImgSignature}
                                      heightImgSignature={heightImgSignature}
                                      pageNumber={pageNumber}
                                      save={async (params) => {
                                        // let temp = {
                                        //   ...params,
                                        //   page: index + 1,
                                        // };
                                        // props.setSignatureImgeData(temp);
                                        await props.setAllSignatures(params)
                                        props.onSubmit();
                                      }}
                                      activeOnSubit={values.activeOnSubit}
                                      signatureData={values.signatureData}
                                      dispatchValues={dispatchValues}
                                      back={() => {
                                        setTimeout(() => {
                                          props.toggleDialogAccept();
                                        }, 100);
                                        // setStep("sign")
                                        // setClicAvailable(false)
                                      }}
                                      cancel={() => {
                                        setStep("sign");
                                        props.onDeleteDataAccept();
                                        setClicAvailable(false)
                                      }}
                                      isMobile={false}
                                      gotToEnd={gotToEnd}
                                      isPhone={isPhone}
                                    />
                                  }
                                </div>
                              </div>
                            )}
                            {step === "instructions" &&
                              <div className="dialog-accept-instructions">
                                <div
                                  ref={greyTextRef}
                                  style={{
                                    // maxWidth: `645px`,
                                    height: "auto",
                                    backgroundColor: "#DEDEDE",
                                    // top: 0,
                                    zIndex: 1,
                                  }}
                                >
                                  <div style={{ padding: "15px 35px 15px 35px" }}>
                                    <p
                                      style={{
                                        margin: "0px",
                                        fontFamily: "Quicksand, sans-serif",
                                        // paddingBottom: "10px",
                                      }}
                                    >
                                      {props.currentUser.proofOfLife ? <>
                                        {t("dialogAcceptSignature.noticeCreateSignAutografa.instructionsText.pt1")}
                                        <strong>
                                          {t("signatureBaseAutograph.btn.capture")}
                                        </strong>
                                        {t("dialogAcceptSignature.noticeCreateSignAutografa.instructionsText.pt2")}
                                      </>
                                        : t(greyText)}
                                    </p>{" "}
                                    {(greyText ===
                                      "dialogAcceptSignature.noticeCreateSignAutografa" && !props.baseSign) && (
                                        <p
                                          style={{
                                            margin: "0px",
                                            fontFamily: "Quicksand, sans-serif",
                                          }}
                                        >
                                          {t("dialogAcceptSignature.noticeCreateSignAutografa2")}
                                        </p>
                                      )}
                                  </div>
                                </div>
                                <div className="dialog-buttons-order">
                                  <ButtonHLPure nameBtn="Cancelar" onClickBtn={() => props.toggleDialogAccept()} />
                                  <ButtonHLPure primary nameBtn="Continuar" onClickBtn={() => setStep("sign")} />
                                </div>
                              </div>
                            }
                            {step === "sign" && (
                              <div
                                className={`${props.baseSign && "button-dialog-accept-baseSign"
                                  } button-dialog-accept-size ${step === "location" &&
                                  "button-on-custom-signature"
                                  }`}
                              >
                                {(props.baseSign && !props.currentUser.proofOfLife) &&
                                  <div style={{ marginTop: '10px' }}>
                                    <ValidationCodePure
                                      data={nip}
                                      setData={setNip}
                                      validationLength={4}
                                      title={t("dialogAcceptSignature.enter.nip")}
                                      hide={true}
                                      autoFocusNIP={true}
                                      handleValidateNip={validateNip}
                                    />
                                  </div>
                                }
                                <div
                                  item
                                  xs={12}
                                  lg={12}
                                  md={12}
                                  sm={12}
                                  es={12}
                                  className={props.currentUser.proofOfLife ? "buttons-faceRecognition-display" : "buttons-sign-display"}
                                >
                                  <ButtonHLPure
                                    nameBtn={t("button.return")}
                                    onClickBtn={() => {
                                      if (props.currentUser.proofOfLife) {
                                        cancelRecording()
                                        setStep("instructions")
                                      } else {
                                        if (props.noRenderSign) {
                                          props.toggleDialogAccept()
                                          setNip('')
                                        } else {
                                          setStep(props.currentUser.proofOfLife ? "instructions" : "location")
                                          setNip('')
                                        }
                                      }
                                      // setClicAvailable(false)
                                      // props.onDeleteDataAccept
                                    }
                                    }
                                  />

                                  {/* Btn clean */}
                                  {
                                    !props.baseSign && (
                                      <ButtonHLPure
                                        nameBtn={t("dialogAcceptSignature.clean")}
                                        onClickBtn={() => {
                                          setClicAvailable(false)
                                          props.setImgSignature(null);
                                          pad.current.clear();
                                          setTimeout(() => {
                                            setNamesInCanvas(props.tokenUserNames, props.tokenUserLastnames, isMobile)
                                          }, 0);
                                          setTimeout(
                                            () =>
                                              props.setImgSignature(saveImage()),
                                            10
                                          );
                                        }}
                                      />
                                    )
                                  }
                                  <ButtonHLPure
                                    disabled={!props.currentUser.proofOfLife ? (!clicAvailable || (props.baseSign && !(nip.length === 4))) : !proofOfLifeValid}
                                    nameBtn={t("dialogAcceptSignature.captureSignature")}
                                    primary
                                    onClickBtn={async () => {
                                      const stampTime = await getStampTimeAndTimezone()
                                      if (props.currentUser.proofOfLife) await stopRecording()
                                      if (stampTime === false) {
                                        props.onErrorTimeStamp()
                                        return false
                                      }
                                      setTextInCanvas(
                                        100,
                                        yPositionCanvas.y3,
                                        `${stampTime}`,
                                        isMobile
                                      );

                                      let {
                                        newImg,
                                        imageWidth,
                                        imageHeight,
                                      } = saveImage(props.currentUser.proofOfLife);
                                      setImgSignature(newImg);

                                      let fileSignImage = null;
                                      await fetch(newImg)
                                        .then((res) => res.blob())
                                        .then((blob) => {
                                          const file = new File(
                                            [blob],
                                            "signature.png"
                                          );
                                          fileSignImage = file;
                                        });
                                      props.toggleLoadingRequesting(true)
                                      let allSignatures = props.signatures.map((signature, index) => {
                                        const item = coordinates[index]
                                        const heightImg = pagesSize[0].height
                                        const hRect = heightImgSignature / 3
                                        return {
                                          ...signature,
                                          x: item.x,
                                          y: -item.y + heightImg - hRect,
                                          width: 208,
                                          height: 100,
                                          index: index + 1,
                                          page: item.page,
                                          heightImg: heightImg,
                                          fileSignImage,
                                          isMobile,
                                          imgSignature: newImg,
                                          fileName: `sign${index + 1}`
                                        }
                                      }
                                      );
                                      props.setAllSignatures(allSignatures);
                                      setWasChanged(true)
                                      props.setImgSignature({
                                        imgSignature: newImg,
                                        imageWidth,
                                        imageHeight,
                                      });
                                      setWidthImgSignature(imageWidth);
                                      setHeightImgSignature(imageHeight);
                                      // setSign(sign);
                                      // if (isMobile) {
                                      //   setShowSignatureCanvas(true);
                                      // } else 
                                      // setStep("location");
                                      props.onSubmit(nip, setNip, stampTime, bufferVideo, imageData);
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </FormElement>
                      );
                    }}
                  />
                </div>
              </Dialog>
            )}
        </div>
      ) : null}
      <div style={{ display: "none" }}>
        <Document
          file={props.result ?? pdfFile}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={e => console.log({ e })}
        >
          <Page
            className={`import-pdf-page-${pageNumber}`}
            pageNumber={pageNumber}
            onRenderSuccess={(params) => onRender(params)}
          />
        </Document>
      </div>
    </div>
  );
};

export { OldDialogAcceptSignatureAutografaCustom as default };